var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833",
    transform: "translate(-335 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(335 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MetaMask",
    transform: "translate(265.532 318.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830",
    transform: "translate(72.9 161.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10095",
    "data-name": "Path 10095",
    d: "M127.074,161.9,120,167.162l1.316-3.106Z",
    transform: "translate(-109.842 -161.9)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4825",
    "data-name": "Group 4825",
    transform: "translate(0.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10096",
    "data-name": "Path 10096",
    d: "M77,161.9l7.031,5.305-1.251-3.149Z",
    transform: "translate(-76.267 -161.9)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10097",
    "data-name": "Path 10097",
    d: "M134.1,218.4l-1.9,2.89,4.054,1.121,1.143-3.947Z",
    transform: "translate(-119.562 -206.215)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10098",
    "data-name": "Path 10098",
    d: "M73.6,218.465l1.143,3.947,4.033-1.121L76.9,218.4Z",
    transform: "translate(-73.6 -206.215)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10099",
    "data-name": "Path 10099",
    d: "M92.521,186.937l-1.121,1.7,3.99.173L95.26,184.5Z",
    transform: "translate(-87.561 -179.626)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10100",
    "data-name": "Path 10100",
    d: "M122.868,186.78l-2.782-2.48L120,188.656l3.99-.173Z",
    transform: "translate(-109.993 -179.469)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10101",
    "data-name": "Path 10101",
    d: "M97.6,221.6l2.415-1.165L97.923,218.8Z",
    transform: "translate(-92.424 -206.529)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10102",
    "data-name": "Path 10102",
    d: "M121.1,220.439l2.394,1.165-.323-2.8Z",
    transform: "translate(-110.856 -206.529)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4826",
    "data-name": "Group 4826",
    transform: "translate(5.327 13.91)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10103",
    "data-name": "Path 10103",
    d: "M123.494,227.565,121.1,226.4l.194,1.553-.022.669Z",
    transform: "translate(-116.032 -226.4)",
    fill: "#083f85",
    className: "metamask"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10104",
    "data-name": "Path 10104",
    d: "M97.6,227.565l2.243,1.057-.022-.669.194-1.553Z",
    transform: "translate(-97.6 -226.4)",
    fill: "#083f85",
    className: "metamask"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    "data-name": "Path 10105",
    d: "M100.906,209.529l-2.006-.582,1.4-.647Z",
    transform: "translate(-93.293 -198.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    "data-name": "Path 10106",
    d: "M121.7,209.529l.582-1.229,1.423.647Z",
    transform: "translate(-111.176 -198.293)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4827",
    "data-name": "Group 4827",
    transform: "translate(3.451 9.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M90.776,221.29l.345-2.89-2.221.065Z",
    transform: "translate(-88.9 -215.23)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M130.7,218.4l.324,2.89,1.9-2.825Z",
    transform: "translate(-121.685 -215.23)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M123.99,203.7l-3.99.173.367,2.049.582-1.229,1.423.647Z",
    transform: "translate(-113.293 -203.7)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M93.017,205.339l1.4-.647.6,1.229.367-2.049L91.4,203.7Z",
    transform: "translate(-90.861 -203.7)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828",
    transform: "translate(3.99 9.015)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    "data-name": "Path 10111",
    d: "M91.4,203.7l1.661,3.257-.043-1.617Z",
    transform: "translate(-91.4 -203.7)",
    fill: "#083f85",
    className: "metamask"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10112",
    "data-name": "Path 10112",
    d: "M130.765,205.339l-.065,1.617,1.682-3.257Z",
    transform: "translate(-122.224 -203.7)",
    fill: "#083f85",
    className: "metamask"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10113",
    "data-name": "Path 10113",
    d: "M108.567,204.5l-.367,2.049.453,2.437.108-3.213Z",
    transform: "translate(-104.577 -204.327)",
    fill: "#083f85",
    className: "metamask"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10114",
    "data-name": "Path 10114",
    d: "M119.294,204.5l-.194,1.272.086,3.213.474-2.437Z",
    transform: "translate(-113.126 -204.327)",
    fill: "#083f85",
    className: "metamask"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10115",
    "data-name": "Path 10115",
    d: "M119.974,211.882l-.474,2.437.345.237,2.07-1.639.065-1.617Z",
    transform: "translate(-109.45 -200.646)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10116",
    "data-name": "Path 10116",
    d: "M98.9,211.3l.043,1.617,2.092,1.639.323-.237-.453-2.437Z",
    transform: "translate(-93.293 -200.646)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10117",
    "data-name": "Path 10117",
    d: "M102.841,232.857l.022-.669-.194-.151H99.994l-.173.151.022.669L97.6,231.8l.776.647,1.6,1.1h2.717l1.6-1.1.776-.647Z",
    transform: "translate(-92.273 -216.725)",
    fill: "#083f85",
    className: "metamask"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10118",
    "data-name": "Path 10118",
    d: "M110.747,225.537l-.345-.237h-1.984l-.323.237-.194,1.553.173-.151h2.674l.194.151Z",
    transform: "translate(-100.352 -211.627)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4829",
    "data-name": "Group 4829",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10119",
    "data-name": "Path 10119",
    d: "M128.238,167.507l.6-2.911-.906-2.7-6.836,5.09,2.631,2.221,3.709,1.078.82-.949-.345-.259.561-.518-.431-.345.561-.431Z",
    transform: "translate(-110.705 -161.9)",
    fill: "#083f85",
    className: "metamask"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M72.9,164.6l.6,2.911-.388.28.561.431-.431.345.582.518-.367.259.82.949,3.731-1.078,2.631-2.221-6.858-5.09Z",
    transform: "translate(-72.9 -161.9)",
    fill: "#083f85",
    className: "metamask"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10121",
    "data-name": "Path 10121",
    d: "M134.97,196.878l-3.709-1.078,1.121,1.7L130.7,200.76l2.221-.022h3.3Z",
    transform: "translate(-118.235 -188.489)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10122",
    "data-name": "Path 10122",
    d: "M78.56,195.8l-3.731,1.078-1.229,3.86h3.3l2.2.022L77.439,197.5Z",
    transform: "translate(-73.449 -188.489)",
    fill: "#083f85",
    className: "metamask",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10123",
    "data-name": "Path 10123",
    d: "M107.294,178.931l.237-4.1,1.078-2.933H103.8l1.078,2.933.237,4.1.086,1.294v3.192h1.984v-3.192Z",
    transform: "translate(-97.136 -169.743)",
    fill: "#083f85",
    className: "metamask"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskWallet);
export default __webpack_public_path__ + "static/media/metamask-wallet.d52abe2843e40ec51d1112c40cbef8b5.svg";
export { ForwardRef as ReactComponent };